import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { useHasVisitId } from 'reservations/base/hooks/useQueryParams';
import { useLoadingSpinner } from 'reservations/base/providers/LoadingSpinnerProvider';
import { useModal } from 'reservations/base/providers/ModalProvider';
import { BaseChecklessPaymentsButton } from 'reservations/checklessPayments/components/BaseChecklessPaymentsButton';
import { ChecklessPaymentsDrawer } from 'reservations/checklessPayments/components/ChecklessPaymentsDrawer';
import { SaveExistingPaymentButton } from 'reservations/checklessPayments/components/SavePaymentButton';
import {
  REMOVE_CARD_HEADER,
  REMOVE_CARD_SUBHEADER
} from 'reservations/checklessPayments/constants';
import { useUnenrollChecklessMutation } from 'reservations/checklessPayments/queries/useUnenrollChecklessMutation';

const RemoveCardModal = () => {
  const { close, isOpen } = useModal();
  const { setValue } = useFormContext();
  const { handleIsLoading } = useLoadingSpinner();
  const hasVisitId = useHasVisitId();
  const unenrollChecklessMutation = useUnenrollChecklessMutation();

  useEffect(() => {
    if (isOpen) {
      setValue('optInChecklessPayments', false);
    }
  }, [isOpen]);

  const handleClickV2 = () => {
    handleIsLoading('');
    unenrollChecklessMutation.mutate();
  };

  const ButtonV1 = () => (
    <SaveExistingPaymentButton buttonText="YES, I'M SURE" handleClick={close} />
  );
  const ButtonV2 = () => (
    <BaseChecklessPaymentsButton
      buttonText="YES, I'M SURE"
      handleClick={handleClickV2}
      dataTestId="remove-card-button-v2"
    />
  );
  const Button = hasVisitId ? ButtonV2 : ButtonV1;

  return (
    <ChecklessPaymentsDrawer
      headerText={REMOVE_CARD_HEADER}
      subheaderText={REMOVE_CARD_SUBHEADER}
    >
      <Button />
    </ChecklessPaymentsDrawer>
  );
};

export default RemoveCardModal;
